'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _interest = require('./interest');

var _interest2 = _interopRequireDefault(_interest);

var _skills = require('./skills');

var _skills2 = _interopRequireDefault(_skills);

var _education = require('./education');

var _education2 = _interopRequireDefault(_education);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMatch = function getMatch(interest, skills, education) {
  var interestValue = 0.5 * interest;
  var skillsValue = 0.35 * skills;
  var educationValue = 0.15 * education;
  return interestValue * 100 + skillsValue * 100 + educationValue;
};

var getMatchForJob = function getMatchForJob(job, user, _ref, constants) {
  var skills = _ref.skills,
      interests = _ref.interests;

  var interestMatch = (0, _keys2.default)(user.interests).length === 0 && user.interests.constructor === Object ? 0 : (0, _interest2.default)(job.interests, user.interests, interests, constants.INTERESTS);

  var skillsMatch = (0, _skills2.default)(job.skills, // array of objects
  user.skills, // array
  skills, constants.SKILLS);

  var educationMatch = user.education ? (0, _education2.default)(job.education.required, user.education, constants.EDUCATION) : 0;

  var matchValue = getMatch(interestMatch, skillsMatch, educationMatch);
  var matchPercentage = matchValue / 100;

  return {
    match: matchPercentage,
    interest: interestMatch,
    skills: skillsMatch,
    education: educationMatch
  };
};

exports.default = getMatchForJob;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/getMatchForJob.js
// module id = 453
// module chunks = 0